import { PBPListResponse } from '@percent/admin-dashboard/services/pbpResponses'
import { currenciesServiceCapabilities, CurrencyInfo } from './currencies.types'

export const currenciesService = ({ percentClient }: currenciesServiceCapabilities) => ({
  getCurrencyInfo: () => percentClient.get<PBPListResponse<CurrencyInfo>>('v1/currencies')
})
